<template>
  <div>
    Privacy Policy
  </div>
</template>
<script>
import { PRIVACY_POLICY_URL } from '../config';

export default {
  metaInfo() {
    return {
      title: this.$t('menu.privacyPolicy'),
    };
  },
  created() {
    console.log('created');
    window.location.href = PRIVACY_POLICY_URL;
  },
};
</script>
<style lang="scss" scoped>
@import '@/assets/scss/common.scss';
a {
  color: $secondary;
  &:hover {
    color: $secondary;
    text-decoration: underline;
  }
}
</style>
